import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import { MAIN_CONTAINER_WIDTH } from '../constants.js';
const MainContainer = memo(({ children, style, minHeight }) => (_jsx("div", { css: css({
        maxWidth: MAIN_CONTAINER_WIDTH,
        width: '100%',
        margin: '0 auto',
        padding: '0 20px',
        ...style,
        minHeight: minHeight || 'initial'
    }), children: children })));
export default MainContainer;
//# sourceMappingURL=index.js.map